import Barcode from 'react-barcode';

import styles from './styles.module.scss';

interface Props {
    value: string;
    height?: number;
    width?: number;
}

function CustomBarcode({ value, height = 30, width }:Props) {
  return (
        <div className={styles.wrapper}
             style={{ height, width }} >
            <Barcode value={value}
                     renderer='img'
                     displayValue={false}
                     margin={0}
                     height={height} />
        </div>
  );
}

export default CustomBarcode;
